/**
 * HTTP headers that name FlatBuffer schemas, as LiftCloud sends and reads them
 * (its `utils/flatbuffers/envelope` package). Every value that names a schema
 * is its SHA-256, as 64 lower-case hex digits.
 */

/**
 * The schema a FlatBuffer HTTP body was written with: on a response the
 * server's `Api.ApiSchema`, on a request this bundle's.
 */
export const SCHEMA_HEADER = "X-LN2-Schema";

/** The schema API's root type of the schema it served. */
export const SCHEMA_ROOT_HEADER = "X-LN2-Schema-Root";

/** Where the server got the schema it served (`compiled`, `ci-signed`, …). */
export const SCHEMA_PROVENANCE_HEADER = "X-LN2-Schema-Provenance";

/**
 * The schema registry's ECDSA P-256 signature of the schema served, as standard
 * base64 of r‖s, when the server learned it from the registry.
 */
export const SCHEMA_SIGNATURE_HEADER = "X-LN2-Schema-Signature";

/** The id of the key `SCHEMA_SIGNATURE_HEADER` verifies with. */
export const SCHEMA_KEY_ID_HEADER = "X-LN2-Schema-Key-Id";

const SCHEMA_HASH = /^[0-9a-f]{64}$/;

/**
 * Whether `value` names a schema the way these headers do: 64 lower-case hex
 * digits. A value that does not is ignored, never put in a URL.
 */
export function isSchemaHash(value: string): boolean {
  return SCHEMA_HASH.test(value);
}
